// /frontend/src/services/settingService.js
import apiClient from '../utils/apiClient';

const API_URL = `${process.env.REACT_APP_API_URL}/settings`;

export const settingService = {
  // Get all settings
  getSettings: async () => {
    try {
      const response = await apiClient.get(API_URL);
      return response.data.data;
    } catch (error) {
      throw error.response?.data?.message || error.message;
    }
  },
  
  // Update settings
  updateSettings: async (settingsData) => {
    try {
      const response = await apiClient.put(API_URL, settingsData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data.data;
    } catch (error) {
      throw error.response?.data?.message || error.message;
    }
  }
};